import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

declare var Persona: any;
declare var window: any;

@Injectable()
export class VeriffService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  // loadVeriffScripts(): Promise<void> {
  //   // return new Promise((resolve, reject) => {
  //   //   const script1 = this.renderer.createElement('script');
  //   //   script1.src = 'https://cdn.withpersona.com/dist/persona-v5.1.2.js';
  //   //   script1.integrity = 'sha384-0LXHuG9ceBdEVRdF698trmE0xe0n9LgW8kNTJ9t/mH3U8VXJy0jNGMw/jPz9W82M';
  //   //         script1.crossorigin = 'anonymous';
  
  //   //   script1.onerror = (error: any) => reject(error);
  //   //   this.renderer.appendChild(document.body, script1);
  //   // });
  // }
   
  initializeVeriff(userId: string) {
      if (typeof Persona === 'undefined' || typeof window.Persona === 'undefined') {
          console.error('Veriff SDK is not loaded.');
          const script = document.createElement('script');
          script.src = 'https://cdn.withpersona.com/dist/persona-v5.1.2.js';
          script.integrity = 'sha384-0LXHuG9ceBdEVRdF698trmE0xe0n9LgW8kNTJ9t/mH3U8VXJy0jNGMw/jPz9W82M';
          script.crossOrigin = 'anonymous';
          script.onload = () => {
              this.initializeVeriff(userId); // Retry initialization after script is loaded
          };
          document.head.appendChild(script);
          return;
      }
  
      const client = new Persona.Client({
          templateId: 'itmpl_wcRLwn3JN9p5x6TSeVAQd9fSDZj9',
          environmentId: 'env_Lv2intUASo2CfFmLUfC2MbhaHpNe',
          onReady: () => client.open(),
          onComplete: ({ inquiryId, status, fields }) => {
              console.log(`Completed inquiry ${inquiryId} with status ${status}`);
          }
      });
  
      console.log(userId);
  }
}


// WEBPACK FOOTER //
// ./src/app/veriff/veriff.service.ts